import { useLocation } from 'react-router-dom'
import useTranslation from '../../hooks/useTranslation'
import { Background, Card, Title, Message } from './styles'

const PortalError = () => {
    const { state } = useLocation()
    const errorName = state?.error?.name || 'error.portal.not.found'

    const { t } = useTranslation()

    return (
        <Background>
            <Card>
                <Title>{t('error.portal.unvailable')}</Title>
                <Message>{t(errorName)}</Message>
            </Card>
        </Background>
    )
}

export default PortalError
